module.exports = __webpack_public_path__ + "static/media/logo.7b6b9d77.svg";